export class PasswordChangeError extends Error {
  failingPass: string;

  constructor(message: string, failingPass: string) {
    super(message); // 'Error' breaks prototype chain here
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    this.failingPass = failingPass;
  }
}
